/* global axios */
import ApiClient from './ApiClient';

class DocumentRequestsAPI extends ApiClient {
  constructor() {
    super('document_requests', { accountScoped: true });
  }

  get(documentId) {
    return axios.get(this.url, { params: { document_id: documentId } });
  }

  create(documentRequest) {
    return axios.post(this.url, { document_request: documentRequest });
  }

  revoke(id) {
    return axios.delete(`${this.url}/${id}/revoke`);
  }
}

export default new DocumentRequestsAPI();
